<ng-container *ngIf="offerCalculator">
  <div [class]="'loc-card card-header-' + theme"
       [class.large-loan]="isLargeLoanProgram"
       fxLayout="column"
       ngClass.lt-md="loc-card-sm"
       ngClass.lt-sm="loc-card-xs">
    <div class="loc-card-header"
         fxLayout="row"
         fxLayoutAlign="start center"
         fxLayoutGap="16px">
      <mat-icon class="header-icon">{{icon}}</mat-icon>
      <div class="header-titles"
           fxLayout="column"
           fxLayoutAlign="center start">
        <span *ngIf="productLabel"
              class="product-label">{{productLabel}}</span>
        <div class="mat-headline-5"
             [class.large-loan-title]="isLargeLoanProgram">{{title}}{{offerCalculator.express ? ' *' : ''}}</div>
      </div>
    </div>
    <div fxLayout="row"
         fxLayoutGap="16px"
         fxLayout.lt-md="column"
         fxLayoutAlign="center center">
      <section>
        <fieldset>
          <legend>
            Draw amount
          </legend>
          <input [class]="'draw-amount card-header-' + theme"
                 currencyMask
                 type="text"
                 [(ngModel)]="offerCalculator.sampleDraw" />
        </fieldset>
        <mat-slider class="slider"
                    color="white"
                    [min]="10000"
                    [max]="offerCalculator.amount"
                    [step]="1000"
                    discrete
                    [displayWith]="onSampleDrawDisplay">
          <input matSliderThumb
                 [(ngModel)]="offerCalculator.sampleDraw">
        </mat-slider>
      </section>
      <section>
        <fieldset>
          <legend>
            Payoff period
          </legend>
          <input [class]="'draw-amount card-header-' + theme"
                 currencyMask
                 type="text"
                 [value]="offerCalculator.sampleDurationDisplay"
                 disabled />
        </fieldset>
        <mat-slider class="slider"
                    color="white"
                    [min]="0"
                    [max]="sampleDurationLength"
                    [step]="1"
                    discrete
                    [displayWith]="onSampleDurationDisplay">
          <input matSliderThumb
                 [(ngModel)]="offerCalculator.sampleDurationIndex">
        </mat-slider>
      </section>
    </div>
    <div class="express-footer"
         *ngIf="offerCalculator.express">
      * Express Checkout is not subject to additional credit underwriting.
    </div>
  </div>
</ng-container>
